<style lang="scss">
.features-panel {
  @include positioningOffset(fixed, 15vh, 0, unset, unset);
  background-color: white;
  //box-shadow: 1px 1px 1px lightgrey;
  z-index: $z-index-top;
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;

  &__icon {
    font-size: 24pt;
    color: $blue-theme;
    text-align: center;
    cursor: pointer;

    .unread {
      @include positioningOffset(absolute, 5px, unset, unset, 5px);
      color: red;
      font-size: 10pt;
    }

    &.raised {
      color: lightgreen;
    }

    &:hover {
      //background-color: #f8f8f8;
    }
  }
}
</style>

<!-- eslint-disable -->
<template>
  <div class="features-panel-wrapper">
    <div class="features-panel menu-shadow">
      <section>
        <p @click="sendHandAcknowledgedMessage()" class="features-panel__icon icon-hand raised m-0 p-1 animate__animate"
           :class="{'d-none': !handRaised}">
          <i class="fas fa-hand-paper"></i>
        </p>
        <p @click="openChatbox(!open)" class="features-panel__icon m-0 p-1 position-relative">
          <i :class="unread ? 'd-inline-block' : 'd-none'" class="fas fa-circle unread"></i>
          <i class="fas fa-comments"></i>
        </p>
      </section>
    </div>

    <chat-box></chat-box>
  </div>

</template>
<!-- eslint-enable -->

<script>
import ChatBox from '@/components/callFeaturesPanel/features/ChatBox.vue';
import { mapState } from 'vuex';

export default {
  components: {
    ChatBox,
  },
  props: {},
  data() {
    return {
      test: '',
    };
  },
  computed: {
    ...mapState({
      open: state => state.callFeatures.chatbox.open,
      unread: state => state.callFeatures.chatbox.unread,
      handRaised: state => state.callFeatures.hand.raised,
      name: state => state.callFeatures.name,
      participantName: state => state.callFeatures.participantName,
    }),
  },
  mounted() {},
  methods: {
    openChatbox(value) {
      this.$store.commit('callFeatures/SET_CHATBOX_OPEN', value);
    },
    sendHandAcknowledgedMessage() {
      this.$store.dispatch('callFeatures/acknowledgeHandRaised').then(() => {
        this.$toast.success(`${this.participantName} as been notified`, {
          toastClassName: ['toast-std', 'success-toast'],
        });
      });
    },
  },
};
</script>
